import { View } from '../base/View';
import { ensureElement } from '../../utils/utils';
export class CatalogView extends View {
    constructor(container, emptyState) {
        super(container);
        this.emptyState = emptyState;
        this._content = ensureElement('.gallery');
    }
    set content(data) {
        const _data = Array.isArray(data) ? data : [data];
        if (_data === null || _data === void 0 ? void 0 : _data.length) {
            this._content.replaceChildren(..._data);
        }
        else {
            this._content.replaceChildren(this.emptyState);
        }
    }
}
